<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="page-title">
          <div class="title">
            <h1>Atoms<a href="https://vikingo.org/engine/docs/atoms" title="Documentation"
              target="_blank"><sup><img src="@/assets/icon/info.svg" width="12" /></sup></a></h1>
          </div>
        </div>
        <div class="pill-control">
          <ul class="nav nav-pills unit-group" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <router-link role="tab" :to="{ name: 'AtomsLocal' }" class="nav-link"
                v-bind:class="{ active: !marketplace }">Local</router-link>
            </li>
            <li class="nav-item" role="presentation">
              <router-link role="tab" :to="{ name: 'AtomsMarketplace' }" class="nav-link"
                v-bind:class="{ active: marketplace }">Marketplace</router-link>
            </li>
          </ul>
        </div>
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa" stroke="currentColor" tabindex="0">
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>
        <div class="head-page" style="margin-bottom: 30px">
          <router-link tag="button" :to="{ name: 'NewAtom', params: { type: 'native' } }"
            class="btn btn-primary btn-lg">
            <i class="vik vik-plus"></i>New atom
          </router-link>
        </div>

        <div class="category-list">
          <h2>Category</h2>
          <ul class="category">
            <li v-for="elem in menuFilter(menuItems, `cat`)" :key="elem.value"
              v-bind:class="{ active: isActiveMenuItem(elem.name, elem.value) }">
              <a @click="addParam(elem.name, elem.value)" type="button">{{
                capitalize(elem.value)
              }}</a>
              <button class="action" v-if="isActiveMenuItem(elem.name, elem.value)" @click="removeParam(elem.name)">
                ×
              </button>
            </li>
          </ul>
        </div>
        <!-- 

        <div class="category-list">
          <h2>Atom type</h2>
          <ul class="category">
            <li
              v-for="elem in menuFilter(menuItems, `type`)"
              :key="elem.value"
              v-bind:class="{ active: isActiveMenuItem(elem.name, elem.value) }"
            >
              <a @click="addParam(elem.name, elem.value)" type="button">{{
                capitalize(elem.value)
              }}</a>
              <button
                class="action"
                v-if="isActiveMenuItem(elem.name, elem.value)"
                @click="removeParam(elem.name)"
              >
                ×
              </button>
            </li>
          </ul>
        </div>
        -->

        <div class="tag-list" v-if="tags">
          <h2>Tags</h2>
          <div class="tags">
            <span v-for="(tag, idx) in tags" :key="idx" v-bind:class="{ active: isActiveMenuItem(`tag`, tag) }"
              @click="addParam(`tag`, tag)">{{ tag }}</span>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="content" ref="loaderLayout">
          <div class="filter-atom">
            <div class="search-group">
              <input type="text" class="form-control form-control-md" placeholder="type a word..." v-model="query" />
              <div class="input-icon">
                <i class="vik vik-search"></i>
              </div>
            </div>

            <div class="display-view ml-auto">
              <button class="btn btn-sm btn-icon grid" @click="setAtomsView(`grid`)"
                :class="[{ active: view == 'grid' }]">
                <i class="vik vik-grid"></i>
              </button>
              <button class="btn btn-sm btn-icon list" @click="setAtomsView(`list`)"
                :class="[{ active: view == 'list' }]">
                <i class="vik vik-list"></i>
              </button>
            </div>
          </div>

          <div class="market-page">
            <div class="filter-result" v-if="paramsToTags().length > 0">
              <div class="filter-result-text">
                <span class="text-bold">{{ totalScripts }} results</span>
                <span>filtered by</span>
              </div>
              <div class="tags">
                <span class="action" v-for="(tag, idx) in paramsToTags()" :key="idx">
                  {{ tag.value }}
                  <a type="button" class="tag-delete" @click="removeParam(tag.name)">×</a>
                </span>
              </div>
            </div>
          </div>

          <div v-if="filteredScripts.length" class="row item-container" v-bind:class="{
            'atom-grid': view == 'grid',
            'atom-list': view == 'list',
          }">
            <div v-bind:class="{
              'col-lg-4': view == 'grid',
              'col-lg-6': view == 'list',
            }" :key="atom.id" v-for="atom in filteredScripts">
              <AtomCard :view="view" :atom="atom" :local="true"></AtomCard>
            </div>
          </div>
          <div v-else>no matches</div>
          <el-pagination background layout="prev, pager, next" :total="totalScripts" @current-change="changePage"
            :hide-on-single-page="true" :page-size="pageSize"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { bus } from "@/bus.js";
import * as utils from "@/utils.js";
import { getScripts, getScriptsTags } from "@/api.js";
import AtomCard from "@/components/internal/AtomCard.vue";
import _ from "lodash";

// import { Scripts } from "@/../wailsjs/go/api/APIC";
// import { LogTrace } from "../../wailsjs/runtime/runtime";

export default {
  components: {
    AtomCard,
  },
  props: ["marketplace"],
  data() {
    return {
      query: "",
      totalScripts: 0,
      pageNum: 1,
      pageSize: 9,
      filteredScripts: [],
      view: "grid",
      menuItems: [
        { name: "type", value: "web" },
        { name: "type", value: "native" },
        { name: "cat", value:"gathering" },
        { name: "cat", value: "security" },
        { name: "cat", value: "admin" },
        { name: "cat", value: "other" },
      ],
      tags: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name) {
        // reset current page num (from/to market/local)
        this.pageNum = 1;
      }
      this.loadScripts();
    },
    query(v) {
      this.queryUpdate();
    },
  },
  mounted() {
    this.loadScripts();
    this.loadScriptsTags();
    let that = this;
    bus.$on("refresh-atoms", function (data) {
      that.loadScripts();
    });
  },
  methods: {
    capitalize(s) {
      return utils.capitalize(s);
    },
    menuFilter(items, name) {
      return items.filter((i) => i.name == name);
    },
    isActiveMenuItem(k, v) {
      return this.$route.query[k] && this.$route.query[k] === v;
    },
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.loadScripts();
    },
    addParam(k, v) {
      utils.addQueryParam(this, k, v);
    },
    removeParam(k) {
      utils.removeQueryParam(this, k);
    },
    paramsToTags() {
      let tags = [];
      let obj = Object.assign({}, this.$route.query);
      for (let name in obj) {
        if (name == "cat" || name == "type" || name == "tag") {
          tags.push({ name: name, value: obj[name] });
        }
      }
      return tags;
    },

    queryUpdate: _.throttle(function () {
      this.loadScripts();
    }, 800),
    async loadScripts() {
      let that = this;
      let params = Object.assign(this.$route.query, { page: this.pageNum, pageSize: this.pageSize, q: this.query });
      if (this.marketplace) {
        let marketQuery = {
          page: this.pageNum,
          pageSize: this.pageSize,
        };

        if (this.$route.query.cat) {
          marketQuery["cat"] = this.$route.query.cat;
        }
        if (this.$route.query.type) {
          marketQuery["type"] = this.$route.query.type;
        }
        if (this.$route.query.tag) {
          marketQuery["tag"] = this.$route.query.tag;
        }
        if (this.query) {
          marketQuery["q"] = this.query;
        }
        let loader = this.$loading.show({
          container: this.$refs.loaderLayout,
          canCancel: false,
          color: "#BDCDD0",
          loader: "dots",
        });


        let atoms = await utils.marketplaceScripts(marketQuery);
        for (var i in atoms) {
          // todo: check if installed
        }
        that.totalScripts = atoms["total"];
        that.filteredScripts = atoms["records"];
        loader.hide()
      } else {
        getScripts(utils.objectToString(params)).then((data) => {
          if (data.error) {
            this.$notify({
              title: "Errror",
              message: data.error,
              type: "error",
            });
            return
          }
          that.totalScripts = data.Total;
          that.filteredScripts = data.Records;
        });
      }
    },
    setAtomsView(v) {
      if (v === "list") {
        this.pageSize = 10;
      } else {
        this.pageSize = 9;
      }
      this.view = v;
      this.loadScripts();
    },
    async loadScriptsTags() {
      let that = this;
      if (this.marketplace) {
        let tags = await utils.marketplaceAtomsTags();
        if (tags && tags.error) {
          // utils.showError(
          //   this,
          //   "Error",
          //   "Failed to load tags from marketplace: " + tags.error
          // );
          return;
        }
        let tagsToObjects = [];
        if (tags && tags.data) {
          for (let i in tags.data) that.tags.push({ value: tags.data[i] });
        }
      } else {
        getScriptsTags().then((res) => {
          this.tags = res.Records;
        });
      }
    },
    getHash() {
      if (this.$route.hash) {
        return this.$route.hash.substring(1);
      }
      return "";
    },
    checkHash() {
      if (this.$route.hash) {
        for (var i in this.sessions) {
          if (this.sessions[i].hash === this.getHash()) {
            this.selectedSessionHash = this.getHash();
          }
        }
      }
    },
  },
};
</script>

<style>
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/pages/Atoms.vue